import React from "react";
import { useDispatch } from "react-redux";

import { initialize } from "src/features/auth/actions";
import { AppDispatch } from "src/store";

export function useInitialize(): void {
	const dispatch: AppDispatch = useDispatch();
	React.useEffect(() => {
		dispatch(initialize());
	}, [dispatch]);
}
